import { render, staticRenderFns } from "./SelectDatasets.vue?vue&type=template&id=65aca334&"
import script from "./SelectDatasets.vue?vue&type=script&lang=js&"
export * from "./SelectDatasets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports